import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "With 90k I could become a full-time author",
  "description": "",
  "published": "2014-07-18T00:00:00.000Z",
  "redirect_from": ["/blog/with-90k-i-could-become-a-full-time-author/swizec/6589"],
  "categories": "Book, Data Visualization, Packt, Royalties, San Francisco, Slovenia, Uncategorized",
  "hero": "./img/images-17899.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e6d6975b86fd84b4263c10b74da464f2/5bd27/images-17899.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.73991031390135%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'183\\'%20viewBox=\\'0%200%20400%20183\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%2020l1%2014h390V7H5v13m2%200v13h387V8H7v12M6%2037l-1%207v6h391V37l-195-1L6%2037m1%207v5h387V38H7v6m-2%209v65l1%2063h390V53l-195-1L5%2053m2%2064v62h387v-19l-1%209v9H8v-49h385v9l1-37V54H7v63m1-26v36h385V55H8v36m1%200v35h383v-14c0-13%200-14-2-13l-2-1c0-1%200-2-1-1v1l-3%201h-2l2-2%201-2v-1h4c1-1%201-1%202%201s1-4%201-18V56H9v35m351-32v5l1-1h1l4%201c3-1%204-1%203%201h1l5-1%203-1h1l6%201c5%200%206%200%206-2%200-1-1-2-4-2l-4-1h-6c0%202-12%202-13%200h-4M11%20118l1%202v1h-2c0%201%209%202%2021%201l1-2%201%201c1%203%202%203%203%202%202-1%203-2%205-1%203%201%206%200%206-1l1-1%201%201v1c3%200%200-4-3-4s-3%200-2%202v1l-1-1c-1-2-15-2-16-1h-1l-2-1h-3c-1-1-2%200-3%201-2%202-2%202-2%200h-3v-2l-2%201m-2%2036v23h383v-16l-4%201c-3%200-5-1-4-4l4-1%204%201v-5c0-4%200-4-1-3h-4c-2%201-3%200-3-3%200-2%201-2%203-2l4%201c1%201%201-2%201-7v-8H9v23m18-7c-1%202%202%205%204%203h7a5103%205103%200%200012-2h1c0%203%208%203%209%200%201-2%200-2-1-1-2%200-2%200-1-1l-2-1-7%201c-3%200-4%201-4%202-1%201-1%201-1-1v-2l-1%202-1%201c0-2-6-3-6%200l-1%201-1-1c0-3-6-4-7-1m1%2012c0%202%200%203%201%202h4l2%201c1-1%202%200%202%201l2-1%201-1c0%202%205%201%205-1h1c0%202%208%203%2010%201%202-1%200-3-4-3h-8c0%201-11%201-12-1-2-2-4-1-4%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6d6975b86fd84b4263c10b74da464f2/ca0a1/images-17899.webp 223w", "/static/e6d6975b86fd84b4263c10b74da464f2/75680/images-17899.webp 445w", "/static/e6d6975b86fd84b4263c10b74da464f2/8d1ba/images-17899.webp 890w", "/static/e6d6975b86fd84b4263c10b74da464f2/3838e/images-17899.webp 1335w", "/static/e6d6975b86fd84b4263c10b74da464f2/275cb/images-17899.webp 1432w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e6d6975b86fd84b4263c10b74da464f2/e92b6/images-17899.png 223w", "/static/e6d6975b86fd84b4263c10b74da464f2/e66bf/images-17899.png 445w", "/static/e6d6975b86fd84b4263c10b74da464f2/4ef49/images-17899.png 890w", "/static/e6d6975b86fd84b4263c10b74da464f2/4e814/images-17899.png 1335w", "/static/e6d6975b86fd84b4263c10b74da464f2/5bd27/images-17899.png 1432w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e6d6975b86fd84b4263c10b74da464f2/4ef49/images-17899.png",
                "alt": "Royalty statement",
                "title": "Royalty statement",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Royalty statement`}</figcaption>{`
  `}</figure></p>
    <p>{`Another three months, another royalty statement from `}<a parentName="p" {...{
        "href": "http://www.packtpub.com",
        "title": "Packt"
      }}>{`Packt`}</a>{`. Three months post facto. Of course.`}</p>
    <p>{`676 euro.`}</p>
    <p>{`About a month's worth of post-tax `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Minimum_wage",
        "title": "Minimum wage"
      }}>{`minimum pay`}</a>{` in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` for nothing but sitting on my arse doing other things. Except it's pre-tax. Still, could be worse.`}</p>
    <p>{`My effective hourly rate for `}<a parentName="p" {...{
        "href": "http://www.packtpub.com/data-visualization-with-d3js/book"
      }}>{`Data Visualization with d3.js `}</a>{`is now €5.1/hour. Up from the €3 it was last time.`}</p>
    <p>{`And that's the beauty of writing books.`}</p>
    <p>{`After the initial blood and sweat and tears, I don't have to do anything. As long as it keeps selling, money keeps hitting my bank account. Were I to do some active promotion and build a newsletter or some manner of business around the books, sales would be even better.`}</p>
    <p>{`Similar to what's happening with my other book - `}<a parentName="p" {...{
        "href": "http://nightowlsbook.com"
      }}>{`Why programmers work at night`}</a>{`. I keep poking at it and doing minor things here and there when I have time, and it keeps selling. It's still not finished, but it makes just enough sales a month to cover my Uber expenses.`}</p>
    <p>{`Which begs the question, why the hell am I still busting my arse freelancing?`}</p>
    <p>{`Well the money's infinitely better, that's true. And I don't make enough from books to cover anything even close to my living expenses.`}</p>
    <p>{`But book revenue is additive. Freelancing revenue is linear.`}</p>
    <p>{`You see, no matter how much better I get at programming and getting clients, my revenue can only scale linearly. It's bound by time and no matter how high my daily or weekly rate can go, there is only so much time. And I'm hitting a ceiling with my rate. And when I break this ceiling, a new one will be waiting just around the corner.`}</p>
    <p>{`With books ... writing four to five a year would give me hockey stick growth.`}</p>
    <p>{`The d3.js book took me 332 hours. With a full-time writing schedule I can fit 6 of those into a year with no days off. With weekends and such I could easily write 5 technical books a year.`}</p>
    <p>{`On topics I don't even know yet. It's a magnificent way to learn, writing a book. That's how the d3.js book happened. I had `}<em parentName="p">{`no`}</em>{` clue about d3.js beforehand.`}</p>
    <p>{`But what about money?`}</p>
    <p>{`Well in its first quarter the book made €1019 of royalties. Second quarter, €676. Assuming a logarithmic fall towards a minimum, next quarter is going to be around 500, then 400 and so on.`}</p>
    <p>{`Eventually sales will reach an asymptotic limit and I'm going to get some €100 a quarter. Or €400 a year. By then it will have made me some €5000 or €6000, spread over some two years.`}</p>
    <p>{`Were I to write five books with similar sales every year I'd be making some €30,000 a year. Just enough to live like a normal person in Slovenia, or barely scrape by in a swanky place like `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7833333333,-122.416666667&spn=0.1,0.1&q=37.7833333333,-122.416666667%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{`.`}</p>
    <p>{`But!`}</p>
    <p>{`This is where the hockey stick comes in. Because book revenue never falls to total zero, my yearly income would grow. Slowly at first, but by the time I was 50 I could live comfortably having done nothing but writing from now until then.`}</p>
    <p>{`If I started writing full-time `}<em parentName="p">{`right now`}</em>{`, I could be making a living off writing in just two or three years. Maybe this is my next in the `}<a parentName="p" {...{
        "href": "http://www.smbc-comics.com/?id=2722"
      }}>{`11 lives you get`}</a>{`?`}</p>
    <p>{`After 17 years I'm getting kind of tired of programming anyway ... anyone want to invest 90k in me becoming a full-time author?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      